<template>
  <div class="areaStatistics">
    <headerNotice routerName="地区统计"></headerNotice>
    <div class="content">
      <h1>地区分析</h1>
      <div class="header">
        <dateSelector @dateChange="getDataByTime"/>
      </div>
      <div v-loading="loading" class="data-wrapper">
        <div id="myChart" class="map"></div>
        <div class="rang">
          <el-table :data="areaData" style="width: 100%">
            <el-table-column align="center" type="index" label="排名" width="50"></el-table-column>
            <el-table-column align="center" property="provinceName" label="省份" width="150"></el-table-column>
            <el-table-column align="center" label="订金金额(￥)" property="amount"></el-table-column>
            <el-table-column align="center" label="占比">
              <template slot-scope="scope">
                <el-progress :percentage="scope.row.proportion | formatPercent"></el-progress>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
import dateSelector from "./dateSelector.vue";
import sumList from "./sumList.vue";
import echarts from "echarts";
import "../../../node_modules/echarts/map/js/china.js";

export default {
  components: {
    headerNotice,
    dateSelector,
    sumList
  },
  props: {},
  data() {
    return {
      loading: false,
      duration: "",
      durationDate: "",
      areaData: [],
      chartData: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    getDataByTime(date) {
      // console.log(date)
      this.getSalesAreaStatistics({
        startTime: date[0],
        endTime: date[1]
      });
    },
    getSalesAreaStatistics(data) {
      let self = this;
      self.loading = true;
      $http.POST({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/AdminStatistics/SalesAreaStatistics",
        data: data,
        success(res) {
          // console.log(res)
          self.areaData = res;
          self.chartData = self.dealChartData(res);
          self.initChart();
          // self.orderData = self.initData(res.items)
          // self.chartData = self.initChartData(self.orderData)
          // self.dataSum = self.getDataSum(res)
          // self.initChart();
          self.loading = false;
          // console.log(self.chartData)
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    dealChartData(data) {
      let arr = [];
      data.forEach(item => {
        let name = item.provinceName;
        if (name === "黑龙江省" || name === "内蒙古自治区") {
          name = name.substring(0, 3);
        } else {
          name = name.substring(0, 2);
        }
        arr.push({
          name: name,
          value: item.amount
        });
      });
      arr.push({
        name: "南海诸岛",
        value: 0,
        itemStyle: {
          normal: { opacity: 0, label: { show: false } },
          emphasis: { opacity: 0, label: { show: false } }
        },
        label: {
          show: false
        },
        tooltip: {
          backgroundColor: "#fff"
        }
      });
      return arr;
    },
    initChart() {
      var myChart = echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        backgroundColor: "#FFFFFF",
        // title: {
        //     text: '全国地图大数据',
        //     subtext: '',
        //     x:'center'
        // },
        tooltip: {
          trigger: "item",
          formatter: "{b}<br/>￥{c}"
        },

        //左侧小导航图标
        // visualMap: {
        // show : true,
        // x: 'left',
        // y: 'center',
        // splitList: [
        //     {start: 500, end:600},{start: 400, end: 500},
        //     {start: 300, end: 400},{start: 200, end: 300},
        //     {start: 100, end: 200},{start: 0, end: 100},
        // ],
        // color: ['#5475f5', '#9feaa5', '#85daef','#74e2ca', '#e6ac53', '#9fb5ea']
        // color: '#05c7b6'
        // },

        //配置属性
        series: [
          {
            name: "数据",
            type: "map",
            mapType: "china",
            roam: true,
            // color: '#05c7b6',
            // label: {
            //     normal: {
            //         show: true  //省份名称
            //     },
            //     emphasis: {
            //         show: false
            //     }
            itemStyle: {
              normal: {
                //未选中状态
                areaColor: "#05c7b6", //背景颜色
                label: {
                  show: true //显示名称
                }
              },
              emphasis: {
                // 也是选中样式
                // areaColor: 'red',
                label: {
                  show: true,
                  // textStyle: {
                  //     color: '#fff'
                  // }
                
                }
              }
            },

            data: this.chartData //数据
          }
        ]
      });
    }
  },
  filters: {
    formatPercent(percent) {
     let value= percent* 100;
      return Number(value.toFixed(2));
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.areaStatistics {
  .content {
    padding: 50px 50px 0;
    h1 {
      padding-left: 20px;
      background: #f3f3f3;
      line-height: 50px;
    }
  }
  .header {
    padding: 20px 0;
  }
  .header {
    padding: 20px 0;
  }
  .data-wrapper {
    display: flex;
    .map {
      flex: 1;
      width: 400px;
      height: 400px;
      // background: green;
    }
    .rang {
      flex: 1;
    }
  }
}
</style>